import ClientList from "../../Join/Client/ClientList";

const RecordsTab = (props) => {
  return <ClientList {...props} />;
};

export default RecordsTab;
